import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar8 from '../components/navbar8'
import Contact3 from '../components/contact3'
import Features9 from '../components/features9'
import Footer4 from '../components/footer4'
import './contact.css'

const Contact = (props) => {
  return (
    <div className="contact-container">
      <Helmet>
        <title>Contact - Sydrisworx</title>
        <meta property="og:title" content="Contact - Sydrisworx" />
      </Helmet>
      <Navbar8
        link1={
          <Fragment>
            <span className="contact-text10">Home</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="contact-text11">Services</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="contact-text12">Contact Us</span>
          </Fragment>
        }
      ></Navbar8>
      <Contact3
        email1={
          <Fragment>
            <span className="contact-text13">Letswork@Sydrisworx.co.za</span>
          </Fragment>
        }
        phone1={
          <Fragment>
            <span className="contact-text14">+27 10 226 9548</span>
          </Fragment>
        }
        address1={
          <Fragment>
            <span className="contact-text15">
              11th Floor Sandton Towers, 5th Street, Sandton, 2196
            </span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="contact-text16">
              <span>
                Feel free to reach out to us for any inquiries or collaboration
                opportunities.
              </span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </span>
          </Fragment>
        }
        content2={
          <Fragment>
            <span className="contact-text19">
              Our team is dedicated to providing you with the best training
              solutions.
            </span>
          </Fragment>
        }
        content3={
          <Fragment>
            <span className="contact-text20">Reach out to us anytime.</span>
          </Fragment>
        }
        content4={
          <Fragment>
            <span className="contact-text21">
              Connect with us today to start your journey towards digital skills
              and empowerment.
            </span>
          </Fragment>
        }
        content5={
          <Fragment>
            <span className="contact-text22">Visit us at our hub.</span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="contact-text23">Contact Us</span>
          </Fragment>
        }
      ></Contact3>
      <Features9
        text={
          <Fragment>
            <span className="contact-text24">Sydrisworx</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="contact-text25">
              <span>Bridge the data &amp; digital gap!</span>
              <br></br>
              <span>IT Services and IT Consulting</span>
            </span>
          </Fragment>
        }
        text11={
          <Fragment>
            <span className="contact-text29">Letswork@Sydrisworx.co.za</span>
          </Fragment>
        }
        imageSrc2="/whatsapp%20image%202025-03-19%20at%2014.57.33_f83ba2ad-1400w.jpg"
        feature1Title={
          <Fragment>
            <span className="contact-text30">Follow Us</span>
          </Fragment>
        }
      ></Features9>
      <Footer4
        link1={
          <Fragment>
            <span className="contact-text31">Home</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="contact-text32">Services</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span className="contact-text33">Contact Us</span>
          </Fragment>
        }
      ></Footer4>
    </div>
  )
}

export default Contact
